import { GridDensity } from "@mui/x-data-grid";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDatagridState {
  density: GridDensity;
  pageSize: number;
}

const storedDensity = localStorage.getItem("density") as GridDensity | null;
const storedPageSize = localStorage.getItem("pageSize");

const initialState: IDatagridState = {
  density: storedDensity ?? "standard",
  pageSize: storedPageSize ? Number(storedPageSize) : 10,
};

const datagridSlice = createSlice({
  name: "datagrid",
  initialState,
  reducers: {
    changeDensity: (state, action: PayloadAction<GridDensity>) => {
      state.density = action.payload;
      localStorage.setItem("density", action.payload);
      if (action.payload === "compact") {
        changePageSize(25);
      }
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
      localStorage.setItem("pageSize", action.payload.toString());
    },
  },
});

export const { changeDensity, changePageSize } = datagridSlice.actions;
export default datagridSlice.reducer;
